import type { InputHTMLAttributes } from "react";

const BASE =
  "rounded-lg border border-app-border bg-surface text-app-text transition-colors focus:border-app-focus focus:outline-none focus:ring-1 focus:ring-app-focus disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500";

const SIZES = {
  md: "px-3 py-2 text-sm",
  sm: "px-2 py-1 text-xs",
} as const;

type InputSize = keyof typeof SIZES;

type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  size?: InputSize;
};

export default function Input({ size = "md", className = "", ...props }: InputProps) {
  const classes = [BASE, SIZES[size], className].filter(Boolean).join(" ");
  return <input className={classes} {...props} />;
}
